import { useMemo } from 'react';
import { useAuthContext } from '../context/AuthContext/AuthContext';
import { usePreorderRules } from '../context/PreorderRulesContext/PreorderRulesContext';
import { useSettingsContext } from '../context/SettingsContext';
import { ROLES } from '../consts/language';

export const usePreorderEnabled = () => {
  const { userInfo } = useAuthContext();
  const { stadiumData: stadiumDataAdmin, isLoading: preRulesLoading } = usePreorderRules();
  const { stadiumData: stadiumDataStaff, loading: settingsLoading } = useSettingsContext();

  const isSuperAdmin = userInfo?.role === ROLES.SUPER_ADMIN || userInfo?.role === ROLES.HEADQUARTER;

  const enabledNewVersion = useMemo(() => {
    const currentStadiumData = isSuperAdmin ? stadiumDataAdmin : stadiumDataStaff;
    return currentStadiumData?.cms_settings?.pre_order || false;
  }, [isSuperAdmin, stadiumDataAdmin, stadiumDataStaff]);

  const isReady = useMemo(() => {
    return isSuperAdmin ? !preRulesLoading : !settingsLoading;
  }, [isSuperAdmin, preRulesLoading, settingsLoading]);

  return { enabledNewVersion, isReady };
};
